import { useState } from "react";
import { Box, Button, Card, CardContent, Stack, TextField, Typography } from "@mui/material";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../router/constants";
import { changePassword } from "../../services/changePassword.service";

export function ChangePassword() {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await changePassword({ currentPassword, newPassword, confirmPassword });
      toast.success("Senha alterada com sucesso.");
      navigate(ROUTES.DASHBOARD);
    } catch (e: any) {
      const msg = e?.response?.data?.message || e?.message;
      toast.error(msg ? String(msg) : "Falha ao alterar senha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 720, mx: "auto", p: 3 }}>
      <Typography variant="h6" fontWeight={800} color="#133859" mb={2}>
        Trocar senha
      </Typography>

      <Card>
        <CardContent>
          <Stack spacing={2}>
            <TextField
              label="Senha atual"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              fullWidth
            />
            <TextField
              label="Nova senha"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              helperText="Mínimo 6 caracteres"
              fullWidth
            />
            <TextField
              label="Confirmar nova senha"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
            />

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} justifyContent="flex-end">
              <Button variant="text" color="inherit" onClick={() => navigate(-1)} disabled={loading}>
                Voltar
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading || !currentPassword || !newPassword || !confirmPassword}
              >
                {loading ? "Salvando..." : "Salvar"}
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
